import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PolicyPdf, PolicySearch, PolicySearchSummary } from '../../interfaces/policy-summary.model';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root',
})
export class PolicySummaryService {
  private baseApiUrl: string = environment.baseApiUrl;
  private readonly _utilsService: UtilsService = inject(UtilsService);

  constructor(private _http: HttpClient) {}

  async getPolicySummary(search: PolicySearch): Promise<PolicySearchSummary> {
    try {
      const result = await firstValueFrom(
        this._http.post<PolicySearchSummary>(`${this.baseApiUrl}/policy/search`, search),
      );
      return result;
    } catch (error) {
      throw error;
    }
  }

  async prepareVariantPdf(policyNumber: string): Promise<{ letterId: string }> {
    try {
      const result = await firstValueFrom(
        this._http.post<{ letterId: string }>(`${this.baseApiUrl}/policy/${policyNumber}/document`, null),
      );
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getVariantPdf(id: string, policyNumber: string): Promise<PolicyPdf> {
    try {
      const result = await firstValueFrom(
        this._http.get<PolicyPdf>(`${this.baseApiUrl}/policy/${policyNumber}/document/${id}`),
      );
      return result;
    } catch (error) {
      throw error;
    }
  }
}
